
import Vue from "vue";
import { UserInfo } from "@/models/dossier/user-info";
import { ISelectItem } from "winfakt-vue-components";
import { DossierService } from "@/services/dossier-service";


export default Vue.extend({
	data(){
		return {
			users: [] as UserInfo[],
		};
	},
	props: {
		value: Number,
	},
	computed: {
		items():ISelectItem<number>[] {
			let result:ISelectItem<number>[] = this.users.map((u) => {
				return {
					text: u.Firstname ? (u.Firstname + " " + u.Lastname) : u.Email,
					value: u.ID
				};
			});
			result.unshift({
				text: this.$ct("common.none"),
				value: 0
			});
			return result;
		}
	},
	methods: {
		onInput(value:number) {
			this.$emit("update",value);
			this.$emit("input",value);
		}
	},
	async created(){
		this.users = await DossierService.getUsers();

	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
